// src/app/u3148Organization/components/form/u3148Role/U3148UseGetOrganizatonRoleHandlers.ts
export interface U3148UseGetOrganizatonRoleHandlersParams<T = any> {
  doGetFn: (id: string, roleId: string) => Promise<any>;
  onSuccess?: (row: T) => void;
  onError?: (errors: { error: any }) => void;
}

// Return type for useU3148UseGetOrganizatonRoleHandlers hook
export interface U3148UseGetOrganizatonRoleHandlersReturn {
  getOrganizationRole: (id: string, roleId: string) => void;
}

// Handlers for getting organization role
export function useU3148UseGetOrganizatonRoleHandlers<T extends { id: string } = any>({
  doGetFn,
  onSuccess,
  onError,
}: U3148UseGetOrganizatonRoleHandlersParams<T>): U3148UseGetOrganizatonRoleHandlersReturn {
  const getOrganizationRole = async (id: string, roleId: string) => {
    try {
      const response = await doGetFn(id, roleId);
      const row: T = response.data.result as unknown as T;

      if (onSuccess) {
        onSuccess(row);
      }
    } catch (error) {
      if (onError) {
        onError({ error });
      }
    }
  };

  return { getOrganizationRole };
}
